<template>
<div>
    <!-- <p class="tasks">Completed Tasks: {{todos.filter(todo => {return todo.done === true}).length}}</p>
    <p class="tasks">Pending Tasks: {{todos.filter(todo => {return todo.done === false}).length}}</p> -->
    <div class="columns" v-for="data in sortByName(studentList)" :key="data.key">
        <div class="column">{{ data.firstName }} {{ data.lastName }}</div>
        <div class="column is-1"><span class='floated trash icon' v-on:click="deleteData(data)"><font-awesome-icon icon="trash-alt" /></span></div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
                level: '',
                name: '',
                kelasID: 0
            },
            result: "",
        };
    },
    props: ['studentList'],
    components: {
    },
    methods: {
        sortByName(arrays){
            return _.orderBy(arrays, 'firstName', 'asc');  //we're using the magical lodash function here                  
        },
        deleteData(data) {
            if (confirm('Are you sure? ' + data.firstName + ' ' + data.lastName + ' will be removed from this group.')) {
                this.input.email = localStorage.getItem('email')
                this.input.groupID = this.$parent.groupID
                this.input.option1 = 'single'
                this.input.studentID = data._id

                const dataIndex = this.studentList.indexOf(data);
                this.studentList.splice(dataIndex, 1);

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/group/students/out', this.input)
                    .then(response => {

                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 10000
                            })
                        } else {
                            Toast.open({
                                message: e,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 10000
                            })
                        }
                    })
            }
        },
    },
};
</script>

<style scoped>
p.tasks {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Database/Group/StudentList.vue